// src/services/buildCommentTree.js

export function buildCommentTree(comments) {
  const commentMap = {}
  const rootComments = []

  // בניית מפה ראשונית של כל התגובות
  comments.forEach((comment) => {
    // מוסיפים key map
    commentMap[comment._id] = { ...comment, replies: [] }
  })

  // שיוך "בן" ל"אב"
  comments.forEach((comment) => {
    if (comment.parentCommentId) {
      const parent = commentMap[comment.parentCommentId]
      if (parent) {
        parent.replies.push(commentMap[comment._id])
      }
    } else {
      rootComments.push(commentMap[comment._id])
    }
  })

  // מיון תגובות root כך שהתגובה עם הכי הרבה לייקים תהיה למעלה
  rootComments.sort((a, b) => b.likes.length - a.likes.length)

  return rootComments
}
